import React, { useEffect } from 'react'
import { Field, ErrorMessage } from 'formik'
import { useDispatch } from 'react-redux'
import { Dropdown, DropdownButton, FormControl, InputGroup } from 'react-bootstrap'

import CustomTooltip from 'components/CustomTooltip'
import { isWasmerFile } from 'utils/general'
import { showCreateSiteModal, showCustomDomainModal, showMessageModal } from 'Manage/actions'
import { ACTION_CREATE, ACTION_UPDATE } from 'components/CreateUpdateSiteModal/interface'
import '../../CreateUpdateSiteModal.css'

const DomainForm = ({
  name,
  initialValues,
  userProfile,
  action,
  setFieldValue,
  uploadValues,
  updatingPhpFile,
  disabled
}) => {
  const dispatch = useDispatch()
  const { domainSuffix, customDomains, tlds } = initialValues
  const { selectedFile } = uploadValues
  const { siteLimit } = userProfile
  const customDomainSuffix = localStorage.getItem('active_custom_domain')

  const onAddCustomDomain = () => {
    dispatch(showCreateSiteModal(false))

    if (siteLimit === customDomains.length) {
      dispatch(showMessageModal({ title: 'Limit reached', message: 'Custom domain limit reached' }))
    } else {
      dispatch(showCustomDomainModal(true))
    }
  }

  const isCustomDomain = (domainSuffix) => !tlds.includes(domainSuffix)

  const onSelectDomainSuffix = (eK, event) => {
    const selectedDomainSuffix = event.target.text
    setFieldValue(`${name}.domainSuffix`, selectedDomainSuffix)
    setFieldValue(`${name}.isCustomDomain`, isCustomDomain(selectedDomainSuffix))
  }

  useEffect(() => {
    if (!!customDomainSuffix) {
      const foundDomain = customDomains.find(
        (item) => `.${item.domain.toLowerCase()}` === customDomainSuffix.toLowerCase()
      )
      if (!!foundDomain && !tlds.includes(customDomainSuffix)) {
        setFieldValue(`${name}.isCustomDomain`, true)
        setFieldValue(`${name}.domainSuffix`, customDomainSuffix)
        setFieldValue(`${name}.subdomain`, localStorage.getItem('active_custom_subdomain'))
      }
    }
  }, [customDomainSuffix])

  useEffect(() => {
    if (isWasmerFile(selectedFile)) {
      setFieldValue(`${name}.domainSuffix`, '.tiiny.io')
    }
  }, [selectedFile])

  const handleBlur = (e) => {
    e.preventDefault()
  }

  return (
    <>
      <InputGroup className="input-domain">
        <InputGroup>
          {/** SUBDOMAIN TEXT INPUT */}
          <Field
            name={`${name}.subdomain`}
            as={FormControl}
            placeholder="link-name"
            aria-label="Subdomain"
            disabled={disabled || updatingPhpFile}
            onBlur={handleBlur}
            onChange={(e) => {
              setFieldValue(`${name}.subdomain`, e.target.value)
            }}
            autoFocus={!disabled && !updatingPhpFile && action === ACTION_UPDATE}
            maxLength={63}
            className="link-name-input"
          />
          {/** END SUBDOMAIN TEXT INPUT */}

          {/** DOMAIN TLD DROPDOWN */}
          <DropdownButton
            id="input-group-dropdown-2"
            variant="primary"
            as={InputGroup.Append}
            title={domainSuffix}
            value={domainSuffix}
            onSelect={onSelectDomainSuffix}
            disabled={disabled}
          >
            {action === ACTION_CREATE && (
              <>
                {/**  select / create custom suffix domain  */}
                {tlds?.map((tld) => (
                  <Dropdown.Item key={tld} value={tld}>
                    {tld}
                  </Dropdown.Item>
                ))}

                {/** custom domains */}
                {!isCustomDomain(domainSuffix) &&
                  !isWasmerFile(selectedFile) &&
                  customDomains?.map((customDomain) => (
                    <Dropdown.Item
                      key={customDomain}
                      value={`.${customDomain.domain}`}
                      active={domainSuffix === `.${customDomain.domain}`}
                    >
                      .{customDomain.domain}
                    </Dropdown.Item>
                  ))}

                {/* Only show divider if the second section visible */}
                {!isCustomDomain(domainSuffix) && !isWasmerFile(selectedFile) && !!customDomains && (
                  <Dropdown.Divider />
                )}
              </>
            )}

            {!isCustomDomain(domainSuffix) && !isWasmerFile(selectedFile) && !!customDomains && (
              <>
                <Dropdown.Item key={1} onClick={onAddCustomDomain}>
                  <span style={{ fontSize: '14px', color: '#333' }}>Add custom domain</span>
                </Dropdown.Item>
              </>
            )}
          </DropdownButton>
          {/** END DOMAIN TLD DROPDOWN */}
        </InputGroup>
      </InputGroup>

      {/** ERROR DOMAIN */}
      <ErrorMessage
        name={`${name}.subdomain`}
        render={() => (
          <div className="mt-1 validation-error text-center">
            {!isCustomDomain(domainSuffix) &&
              'Invalid link-name: Only letters, numbers, and hyphens/dashes are allowed.'}
            {isCustomDomain(domainSuffix) && 'Please enter a valid subdomain or "www"'}
            <CustomTooltip label="Please select a different link name for your site.">
              <span className="link ms-2">
                <u>Help</u>
              </span>
            </CustomTooltip>
          </div>
        )}
      />
      {/** END ERROR DOMAIN */}
    </>
  )
}

export default DomainForm
